import React, { Component } from "react";
import _ from "lodash";

class NavBlockOmaha extends Component {
  render() {
    let boxStyle = {
      border: "1px",
      backgroundColor: _.get(this.props, "background", "#8c827a"),
      height: "19.52vh",
      width: "20vh",
      float: "left",
      marginLeft: this.props.marginLeft,
      boxShadow: "3px 3px 20px 0px rgba(0,0,0,0.75)"
    };

    return (
      <div style={{ ...boxStyle }}>
        <div style={{ display: "block", marginTop: "2.11vh" }}>
          <img style={{ height: "7.902777778vh" }} src={this.props.icon} alt="" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "2.2vh",
            marginLeft: "2vh",
            marginRight: "2vh",
            height: "6.507222222vh"
          }}
        >
          <span>{this.props.title.toUpperCase()}</span>
        </div>
      </div>
    );
  }
}

export default NavBlockOmaha;



// WEBPACK FOOTER //
// ./src/Components/Theme/Omaha/NavBlockOmaha.jsx